export default "__VITE_ASSET__BUdo90du__"